"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.StripePayment = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var stripe_js_1 = require("@stripe/stripe-js");
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var button_1 = __importDefault(require("@atlaskit/button"));
var select_1 = __importDefault(require("@atlaskit/select"));
var LoadingSpinner_1 = require("../LoadingSpinner");
var contexts_1 = require("../../../contexts");
var trello_1 = require("@powerupsclub/trello");
var prices_1 = require("../../../prices");
var stripePromise = (0, stripe_js_1.loadStripe)(process.env.REACT_APP_STRIPE_KEY ||
    'pk_test_51IzTPSE4AkBCYcbadpOO6rS1LdyYfD0oGq4NboxTExCqO4KwS3Sg24lT2FU7uqP8NAATNRffWxcHozWwukJH19wd00elcjQbhl');
var SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:3001';
var CheckoutForm = function (_a) {
    var selectedProduct = _a.selectedProduct, onComplete = _a.onComplete, onContinueTrial = _a.onContinueTrial;
    var stripe = (0, react_stripe_js_1.useStripe)();
    var elements = (0, react_stripe_js_1.useElements)();
    var trelloIframe = (0, react_1.useContext)(trello_1.TrelloPowerUpContext).trelloIframe;
    var _b = (0, react_1.useState)(null), message = _b[0], setMessage = _b[1];
    var _c = (0, react_1.useState)(false), isLoading = _c[0], setIsLoading = _c[1];
    (0, react_1.useEffect)(function () {
        if (!stripe) {
            return;
        }
        var clientSecret = new URLSearchParams(window.location.search).get('payment_intent_client_secret');
        if (!clientSecret) {
            return;
        }
        stripe.retrievePaymentIntent(clientSecret).then(function (_a) {
            var paymentIntent = _a.paymentIntent;
            switch (paymentIntent.status) {
                case 'succeeded':
                    setMessage('Payment succeeded!');
                    break;
                case 'processing':
                    setMessage('Your payment is processing.');
                    break;
                case 'requires_payment_method':
                    setMessage('Your payment was not successful, please try again.');
                    break;
                default:
                    setMessage('Something went wrong.');
                    break;
            }
        });
    }, [stripe]);
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!stripe || !elements) {
                        // Stripe.js has not yet loaded.
                        // Make sure to disable form submission until Stripe.js has loaded.
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    return [4 /*yield*/, stripe
                            .confirmPayment({
                            elements: elements,
                            confirmParams: {
                                // Make sure to change this to your payment completion page
                                return_url: 'https://pupsclub.loca.lt/payment'
                            },
                            redirect: 'always'
                        })["catch"](function (e) {
                            if (e.message.includes('redirect_status=succeeded')) {
                                onComplete();
                            }
                        })];
                case 1:
                    result = _a.sent();
                    if (result && result.error) {
                        error = result.error;
                        if (error.type === 'card_error' || error.type === 'validation_error') {
                            setMessage(error.message);
                        }
                        else {
                            setMessage('An unexpected error occurred.');
                        }
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("form", __assign({ id: "payment-form", onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(react_stripe_js_1.PaymentElement, { id: "payment-element" }, void 0), message && (0, jsx_runtime_1.jsx)("div", __assign({ id: "payment-message" }, { children: message }), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({ style: { marginTop: '12px' } }, { children: [(0, jsx_runtime_1.jsx)(button_1["default"], __assign({ type: "submit", isDisabled: isLoading || !stripe || !elements, appearance: "primary" }, { children: selectedProduct === 'workspace'
                            ? trelloIframe.localizeKey('purchase-workspace-license')
                            : selectedProduct === 'individual'
                                ? trelloIframe.localizeKey('purchase-membership')
                                : trelloIframe.localizeKey('purchase-powerup-license') }), void 0), onContinueTrial && ((0, jsx_runtime_1.jsx)(button_1["default"], __assign({ onClick: onContinueTrial, style: { marginLeft: '8px' } }, { children: trelloIframe.localizeKey('continue-with-free-trial') }), void 0))] }), void 0)] }), void 0));
};
var StripePayment = function (_a) {
    var _b;
    var selectedProduct = _a.selectedProduct, numberOfWorkspaceMembers = _a.numberOfWorkspaceMembers, onComplete = _a.onComplete, setSelectedProduct = _a.setSelectedProduct, onContinueTrial = _a.onContinueTrial;
    var _c = (0, react_1.useState)(''), clientSecret = _c[0], setClientSecret = _c[1];
    var _d = (0, react_1.useState)('workspace'), individualOrWorkspaceForPowerUpLicense = _d[0], setIndividualOrWorkspaceForPowerUpLicense = _d[1];
    var _e = (0, react_1.useState)('yearly'), billingCadence = _e[0], setBillingCadence = _e[1];
    var _f = (0, react_1.useContext)(trello_1.TrelloPowerUpContext), powerUpKey = _f.powerUpKey, appName = _f.appName, org = _f.org, isLoadingTrello = _f.isLoading, token = _f.token, trelloIframe = _f.trelloIframe;
    var isLoadingPayments = (0, react_1.useContext)(contexts_1.PaymentsContext).isLoading;
    var _g = (0, react_1.useState)(true), isLoadingIntent = _g[0], setIsLoadingIntent = _g[1];
    var isLoading = isLoadingIntent || isLoadingTrello || isLoadingPayments;
    (0, react_1.useEffect)(function () {
        // Create PaymentIntent as soon as the page loads
        setIsLoadingIntent(true);
        trelloIframe.jwt({ state: JSON.stringify({ token: token }) }).then(function (jwt) {
            return fetch("".concat(SERVER_URL, "/v2/payments/create-payment-intent"), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    selectedProduct: selectedProduct,
                    individualOrWorkspaceForPowerUpLicense: individualOrWorkspaceForPowerUpLicense,
                    numberOfWorkspaceMembers: numberOfWorkspaceMembers,
                    billingCadence: billingCadence,
                    powerUpKey: powerUpKey,
                    idOrg: org.id,
                    jwt: jwt
                })
            })
                .then(function (res) { return res.json(); })
                .then(function (data) { return setClientSecret(data.clientSecret); })
                .then(function () { return setIsLoadingIntent(false); })["catch"](function (e) {
                if (selectedProduct === 'workspace') {
                    setSelectedProduct('individual');
                }
            });
        });
    }, [
        selectedProduct,
        numberOfWorkspaceMembers,
        billingCadence,
        individualOrWorkspaceForPowerUpLicense,
    ]);
    var powerUpIndividualOrWorkspaceOptions = [
        {
            label: trelloIframe.localizeKey('individual-powerup-license', {
                powerUpName: appName
            }),
            value: 'individual'
        },
        {
            label: trelloIframe.localizeKey('workspace-powerup-license', {
                powerUpName: appName
            }),
            value: 'workspace'
        },
    ];
    var options = (0, react_1.useMemo)(function () {
        if (selectedProduct === 'individual') {
            return [
                {
                    label: trelloIframe.localizeKey('$9.99 (usd) per month'),
                    value: 'monthly'
                },
                {
                    label: trelloIframe.localizeKey('$100 (usd) per year - save 16%'),
                    value: 'yearly'
                },
            ];
        }
        else if (selectedProduct === 'workspace') {
            return [
                {
                    label: trelloIframe.localizeKey('workspace-billed-monthly', {
                        total: "$".concat((numberOfWorkspaceMembers * 9.99).toFixed(2)),
                        quantity: numberOfWorkspaceMembers,
                        price: '$9.99'
                    }),
                    value: 'monthly'
                },
                {
                    label: trelloIframe.localizeKey('workspace-billed-yearly', {
                        total: "$".concat(numberOfWorkspaceMembers * 100),
                        quantity: numberOfWorkspaceMembers,
                        price: '$100'
                    }),
                    value: 'yearly'
                },
            ];
        }
        else {
            return __spreadArray([], (individualOrWorkspaceForPowerUpLicense === 'individual'
                ? [
                    {
                        label: trelloIframe.localizeKey('powerup-individual-billed-monthly', {
                            price: prices_1.prices[powerUpKey].monthly
                        }),
                        value: 'monthly'
                    },
                    {
                        label: trelloIframe.localizeKey('powerup-individual-billed-yearly', {
                            price: prices_1.prices[powerUpKey].yearly
                        }),
                        value: 'yearly'
                    },
                ]
                : [
                    {
                        label: trelloIframe.localizeKey('powerup-workspace-billed-monthly', {
                            total: "$".concat((numberOfWorkspaceMembers * prices_1.prices[powerUpKey].monthly).toFixed(2)),
                            quantity: numberOfWorkspaceMembers,
                            price: prices_1.prices[powerUpKey].monthly
                        }),
                        value: 'monthly'
                    },
                    {
                        label: trelloIframe.localizeKey('powerup-workspace-billed-yearly', {
                            total: "$".concat((numberOfWorkspaceMembers * prices_1.prices[powerUpKey].yearly).toFixed(2)),
                            quantity: numberOfWorkspaceMembers,
                            price: prices_1.prices[powerUpKey].yearly
                        }),
                        value: 'yearly'
                    },
                ]), true);
        }
    }, [
        selectedProduct,
        numberOfWorkspaceMembers,
        individualOrWorkspaceForPowerUpLicense,
    ]);
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(LoadingSpinner_1.LoadingSpinner, {}, void 0);
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [selectedProduct === 'powerup' && ((0, jsx_runtime_1.jsx)("div", __assign({ style: { marginBottom: '12px' } }, { children: (0, jsx_runtime_1.jsx)(select_1["default"], { value: powerUpIndividualOrWorkspaceOptions[individualOrWorkspaceForPowerUpLicense === 'individual' ? 0 : 1], options: powerUpIndividualOrWorkspaceOptions, isSearchable: false, onChange: function (option) {
                        return setIndividualOrWorkspaceForPowerUpLicense(option.value);
                    } }, void 0) }), void 0)), (0, jsx_runtime_1.jsx)("div", __assign({ style: { marginBottom: '12px' } }, { children: (0, jsx_runtime_1.jsx)(select_1["default"], { value: options[billingCadence === 'monthly' ? 0 : 1], options: options, isSearchable: false, onChange: function (option) {
                        return setBillingCadence(option.value);
                    } }, void 0) }), void 0), clientSecret && ((0, jsx_runtime_1.jsx)(react_stripe_js_1.Elements, __assign({ options: {
                    clientSecret: clientSecret,
                    appearance: {
                        theme: ((_b = document
                            .querySelector('html')) === null || _b === void 0 ? void 0 : _b.getAttribute('data-color-mode')) === 'dark'
                            ? 'night'
                            : 'stripe'
                    }
                }, stripe: stripePromise }, { children: (0, jsx_runtime_1.jsx)(CheckoutForm, { setSelectedProduct: setSelectedProduct, selectedProduct: selectedProduct, numberOfWorkspaceMembers: numberOfWorkspaceMembers, onComplete: onComplete, onContinueTrial: onContinueTrial }, void 0) }), void 0))] }, void 0));
};
exports.StripePayment = StripePayment;
//# sourceMappingURL=StripePayment.js.map